// material-ui
import { alpha } from '@mui/material/styles';

// ==============================|| OVERRIDES - DIALOG ||============================== //

export default function Dialog() {
  return {
    MuiDialog: {
      defaultProps: {
        maxWidth: 'sm',
        fullWidth: true
      },
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: alpha('#000', 0.7)
          },
          '& .MuiDialog-paper': { bgcolor: 'background.paper', backgroundImage: 'none', padding: 8 }
        }
      }
    }
  };
}
